import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { StripePrice } from '@/modules/billing/models/stripe/StripePrice';
import { StripeTaxAmount } from '@/modules/billing/models/stripe/StripeTaxAmount';

export class StripeInvoiceLineItem extends BaseModel {
  public invoiceItem: string;

  public amount: number;

  public amountExcludingTax: number;

  public description?: string;

  public quantity: number;

  public price: StripePrice;

  public taxAmounts: StripeTaxAmount[];

  constructor(model: Partial<StripeInvoiceLineItem> = {}) {
    super(model);

    this.invoiceItem = model.invoiceItem as string;
    this.amount = model.amount as number;
    this.amountExcludingTax = model.amountExcludingTax as number;
    this.description = model.description;
    this.quantity = model.quantity as number;
    this.price = StripePrice.mapModel(model.price);
    this.taxAmounts = StripeTaxAmount.mapModels(model.taxAmounts);
  }
}
